import { isPlainObject, customUnitTranform } from '@/utils/index'
import propTrans from './propTrans.js'
export function getFinalConfigAndStyles(props, configData, existFinalConfig) {
  const defaultProps = props.reduce((defaultProps, propItem) => {
    const { name, defaultValue } = propItem
    defaultProps[name] = typeof defaultValue === 'object' ? JSON.parse(JSON.stringify(defaultValue)) : defaultValue 
    return defaultProps
  }, {})
  
  const propTypeMap = props.reduce((mapObj, propItem) => {
    const { name, type } = propItem
    mapObj[name] = type
    return mapObj
  }, {})
  
  const unitMap = props.reduce((mapObj, propItem) => {
    const { name, unit } = propItem
    mapObj[name] = unit
    return mapObj
  }, {})

  const formatterMap = props.reduce((mapObj, propItem) => {
    const { name, formatter } = propItem
    formatter && (mapObj[name] = formatter)
    return mapObj
  }, {})
  const getFinalConfig = () => {
    const config = {...defaultProps}
    Object.entries(configData).forEach(([key, value]) => {
      if (isPlainObject(value) && isPlainObject(config[key])) {
        config[key] = {...config[key], ...value}
      } else {
        config[key] = configData[key] ?? config[key]
      }
    })
    Object.entries(config).forEach(([key, value]) => {
      if (formatterMap[key] && typeof formatterMap[key] === 'function') {
        value = formatterMap[key](value)
      }
      if (['number', 'string'].includes(typeof value)) {
        config[key] = value + (unitMap[key] || '')
      }
      if (propTrans[propTypeMap[key]]) {
        config[key] = propTrans[propTypeMap[key]](value)
      }
    })
    return config
  }

  const finalConfig = existFinalConfig ?? getFinalConfig()
  const getStyle = () => {
    const styleObject = {}
    Object.entries(finalConfig).forEach(([key, value]) => {
      if (isPlainObject(value)) {
        Object.entries(value).forEach(([subKey, value]) => {
          styleObject[`--${key}_${subKey}`] = customUnitTranform(subKey, value)
        })
      } else {
        styleObject[`--${key}`] = customUnitTranform(key, value)
      }
    })
    return styleObject
  }
  const finalStyle = getStyle()
  return [finalConfig, finalStyle]
}